import { Box } from "@mui/material";
import { useGameDetailsQuery } from "entities/game/queries/useGameDetailsQuery";
import { FC } from "react";
import { useImageUrl } from "shared/hooks/useImageUrl";
import GameImage from "./components/GameImage";
import GameInfo from "./components/GameInfo";
import { GameCardSkeleton } from "./components/Skeleton";
import { AnimatedGameImage, AnimatedGameInfo } from "./styled";

interface GameCardProps {
  gameId: string;
  imageWidth: string;
  imageHeight: string;
  maxWidth: string;
  marginLeft?: string;
  titleVariant?: "bodySMedium" | "bodySSemiBold";
  subtitleVariant?: "bodyXSSemiBold" | "bodyXSMedium";
  index?: number;
  isNewlyGenerated?: boolean;
}

const GameCard: FC<GameCardProps> = ({
  gameId,
  imageWidth,
  imageHeight,
  maxWidth,
  marginLeft,
  titleVariant = "bodySSemiBold",
  subtitleVariant = "bodyXSMedium",
  index = 0,
  isNewlyGenerated = false,
}) => {
  const { data, isLoading } = useGameDetailsQuery(gameId);
  const imageUrl = useImageUrl(data?.bgImage);

  if (isLoading) {
    return (
      <GameCardSkeleton
        width={imageWidth}
        height={imageHeight}
        marginLeft={marginLeft}
      />
    );
  }

  return (
    <Box sx={{ maxWidth, marginLeft }}>
      <AnimatedGameImage delay={index} isNewlyGenerated={isNewlyGenerated}>
        <GameImage
          imageUrl={imageUrl}
          altText={data?.displayName || ""}
          width={imageWidth}
          height={imageHeight}
        />
      </AnimatedGameImage>
      <AnimatedGameInfo delay={index} isNewlyGenerated={isNewlyGenerated}>
        <GameInfo
          name={data?.displayName}
          studio={data?.productName}
          maxWidth={maxWidth}
          titleVariant={titleVariant}
          subtitleVariant={subtitleVariant}
        />
      </AnimatedGameInfo>
    </Box>
  );
};

export default GameCard;
